function sortSegmentsByPriceDesc(segmentBaggages) {
    const segments = [...segmentBaggages];
    segments
        .sort((a, b) => a.selectableBaggageDescriptor[1].price < b.selectableBaggageDescriptor[1].price ? 1 : -1);

    return segments;
}

function getOneClickGroups(baggages, options = {isAnItineraryTrip: false}) {
    const sortedSegments = sortSegmentsByPriceDesc(baggages.segmentBaggages);

    function selection(index) {
        const item = sortedSegments[0].selectableBaggageDescriptor[index + 1];
        const selectedKilos = item.baggageDescriptor.kilos;
        const group = [];
        group[ordinalMap[item.baggageDescriptor.idRow]] = item;
        for (let i = 1; i < sortedSegments.length; i++) {
            const segment = sortedSegments[i].selectableBaggageDescriptor;
            const minWeightDifference = getMinWeightDifference(segment, selectedKilos);
            const filteredSegment = filterBaggageByWeightDifference(selectedKilos, segment, minWeightDifference);
            const cheapest = cheapestOption(filteredSegment);

            group[ordinalMap[cheapest.baggageDescriptor.idRow]] = cheapest;
        }

        return group;
    }

    function min(group, property) {
        return group.reduce((acc, item) => {
            return Math.min(acc, item[property]);
        }, Infinity);
    }

    const bagOptions = sortedSegments[0].selectableBaggageDescriptor.slice(1).map((item, index) => {
        const group = selection(index);

        const calc = (group, property) => {
            const value = min(group, property);
            return options.isAnItineraryTrip ? value / 2 : value;
        };
        return {
            price: calc(group, 'price'),
            primePrice: calc(group, 'primePrice'),
            kilos: item.baggageDescriptor.kilos,
            pieces: item.baggageDescriptor.pieces,
            group,
        };
    });

    return {
        options: bagOptions,
        selection: (index) => {
            const selection = bagOptions[index];
            this.__selection__ = selection.group;
            return selection;
        },
    };
}

function getMinWeightDifference(segment, selectedKilos) {
    return segment.reduce((acc, bag) => {
        const descriptor = bag.baggageDescriptor;
        const difference = Math.abs(descriptor.kilos - selectedKilos);
        if (descriptor.kilos > 0 && difference < acc) {
            return difference;
        }
        return acc;
    }, Infinity);
}

function filterBaggageByWeightDifference(selectedKilos, segment, minWeightDifference) {
    return segment.filter((bag) => {
        const descriptor = bag.baggageDescriptor;
        return descriptor.kilos > 0 &&
            Math.abs(descriptor.kilos - selectedKilos) === minWeightDifference;
    });
}

function cheapestOption(filteredSegment) {
    return filteredSegment.reduce((acc, bag) => {
        if (bag.price < acc.price) {
            return bag;
        }
        return acc;
    }, {price: Infinity});
}

function isInScope(baggageInformation) {
    const value = Odigeo.SessionScope.flow === 'desktop' &&
        Odigeo.AB.isCheckedBagsOneClickDesktop &&
        isBaggageNotIncludedInSegments(baggageInformation) &&
        isSelectableBaggageAvailableInAllSegments(baggageInformation);
    this.__isInScope__ = value;

    return value;
}

function isBaggageNotIncludedInSegments(baggageInformation) {
    return !baggageInformation.some((baggage) =>
        baggage.segmentBaggages.some((segmentBaggage) => {
            const includedDescriptor = segmentBaggage.baggageDescriptorIncludedInPrice;
            return includedDescriptor.kilos !== 0 || includedDescriptor.pieces !== 0;
        })
    );
}

function isSelectableBaggageAvailableInAllSegments(baggageInformation) {
    return !baggageInformation.some((baggage) =>
        baggage.segmentBaggages.some(
            (segmentBaggage) => segmentBaggage.selectableBaggageDescriptor.length === 0
        )
    );
}


function isDifferentSelection(selection = []) {
    const firstItem = selection[0];
    for (let i = 1; i < selection.length; i++) {
        if (Odigeo.AB.isCheckedBagsOneClickDesktop && !equalM(firstItem, selection[i])) {
            return true;
        }
    }

    function equalM(model1, model2) {
        return model1.price === model2.price && equalD(model1, model2);
    }

    function equalD(model1, model2) {
        return model1.baggageDescriptor.kilos === model2.baggageDescriptor.kilos &&
            model1.baggageDescriptor.pieces === model2.baggageDescriptor.pieces;
    }

    return false;
}

function isSimilarSelection(selection, currentModel) {
    if (Odigeo.AB.isCheckedBagsOneClickDesktop && (selection && selection.length > 0)) {
        const prices = selection.map((item) => item.price);
        const minPrice = Math.min(...prices);
        const selectedBag = selection.find((item) => item.price === minPrice);

        return !equalsModels(selectedBag, currentModel);
    }

    return false;
}

function equalsModels(backendModel, bbModel) {
    return backendModel.price === bbModel.get('price') &&
        equalsDescriptors(backendModel, bbModel);
}

function equalsDescriptors(backendModel, bbModel) {
    return backendModel.baggageDescriptor.kilos === bbModel.get('kilos') &&
        backendModel.baggageDescriptor.pieces === bbModel.get('pieces');
}

const ordinalMap = {
    FIRST: 0,
    SECOND: 1,
    THIRD: 2,
    FOURTH: 3,
    FIFTH: 4,
    SIXTH: 5,
};
function isSelectionFromOneClick(idRow, selectedBaggage) {
    if (this.__selection__) {
        const selectionFromOneClick = this.__selection__[ordinalMap[idRow]];
        return Boolean(selectionFromOneClick) && equalsModels(selectionFromOneClick, selectedBaggage);
    }

    return false;
}

module.exports = {
    isInScope,
    getOneClickGroups,
    isDifferentSelection,
    isSimilarSelection,
    isSelectionFromOneClick,
};
